import { AjaxService } from "../Helpers/AjaxService";
import { TaskWithAction } from "../Models/Tasks/TaskWithAction";
export class TaskApi {
    private static instance: TaskApi;
    static getInstance() { return TaskApi.instance || (TaskApi.instance = new TaskApi()); }

    getTasks(): Promise<TaskWithAction[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = "/api/task/getGrowerTasks";
        return new Promise<TaskWithAction[]>((resolve) => {
            ajaxService.get(apiUrl,
                (result: TaskWithAction[]) => {
                    resolve(result);
                });
        });
    }
}